import React, { createContext, useState, useEffect, useContext } from "react";
import * as API from "../utils/api";

export const OrganisationContext = createContext();

const OrganisationContextProvider = ({ children }) => {
  const [appData, setAppData] = useState({
    appName: "",
    clientName: "",
    companyData: null,
  });

  const getOrganizationData = async () => {
    try {
      const data = await API.getOrganizationData();
      if (data) {
        localStorage.setItem("themeData", JSON.stringify(data));
        setAppData({
          appName: data.name,
          clientName: data.clientName,
          companyData: data,
        });
      }
    } catch (error) {
      // console.error("Error fetching organization data: ", error);
    } finally {
    }
  };

  useEffect(() => {
    getOrganizationData();
  }, []);

  return (
    <OrganisationContext.Provider value={{ appData }}>
      {children}
    </OrganisationContext.Provider>
  );
};

export const useOrganization = () => {
  return useContext(OrganisationContext);
};

export default OrganisationContextProvider;
